<template>
    <div>
        <v-card>
            <v-card-title class="pb-0 headline">Filtro de estudiantes</v-card-title>
            <v-card-text class="pt-0">
                <v-flex xs12 sm12>
                    <v-alert
                        v-model="showErrorDataLoadedAlert"
                        type="error"
                        dismissible
                        transition="scale-transition"
                        dark
                    >
                        No se han podido cargar todos los datos necesarios para este filtro.
                        <br />
                        Intente cargar el filtro nuevamente.
                    </v-alert>

                    <template>
                        <v-container style="max-width: 500px" class="pa-1">
                            <v-autocomplete
                                v-model="selectedCampos"
                                class="pt-0"
                                :items="inputs"
                                item-value="text"
                                return-object
                                hide-selected
                                placeholder="Selecciones los campos para filtrar..."
                                multiple
                                persistent-hint
                                deletable-chips
                                small-chips
                                dense
                                clearable
                                tags
                                ref="selectedCamposRef"
                            >
                            </v-autocomplete>

                            <v-divider></v-divider>

                            <v-flex class="my-1" align="center">
                                <v-layout>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 black--text">
                                            Filtros: {{ selectedCampos.length }}
                                        </strong>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                                    </v-fade-transition>

                                    <v-spacer></v-spacer>

                                    <v-btn color="success" small class="my-0" @click="applyFilter()">
                                        Aplicar
                                    </v-btn>
                                </v-layout>
                            </v-flex>

                            <v-divider class="mb-4"></v-divider>

                            <v-card v-if="selectedCampos.length > 0">
                                <v-list>
                                    <v-slide-y-transition class="py-0" group tag="v-list">
                                        <template v-for="(campo, i) in selectedCampos">
                                            <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                            <v-list-tile :key="campo.id">
                                                <v-list-tile-action>
                                                    <v-checkbox
                                                        v-model="campo.activo"
                                                        :disabled="selectedCampos[i].value.length === 0"
                                                        color="info"
                                                        class="mt-3"
                                                    >
                                                    </v-checkbox>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <template v-if="campo.text === 'Fecha de nacimiento'">
                                                        <v-menu
                                                            ref="menuFechaNacimiento"
                                                            v-model="menuFechaNacimiento"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaNacimientoFormatted"
                                                                    label="Fecha nacimiento"
                                                                    readonly
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFechaNacimiento = parseDate(
                                                                            selectedCampos[i].value
                                                                        )
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFechaNacimiento"
                                                                no-title
                                                                scrollable
                                                                @input="menuFechaNacimiento = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Pago inicial'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { nombre: 'Si', value: '1' },
                                                                { nombre: 'No', value: '0' }
                                                            ]"
                                                            :label="campo.text"
                                                            item-text="nombre"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Fecha de alta'">
                                                        <v-menu
                                                            ref="menuFechaAlta"
                                                            v-model="menuFechaAlta"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaAltaFormatted"
                                                                    label="Fecha de alta"
                                                                    readonly
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFechaAlta = parseDate(
                                                                            selectedCampos[i].value
                                                                        )
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFechaAlta"
                                                                no-title
                                                                scrollable
                                                                @input="menuFechaAlta = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Fecha de baja'">
                                                        <v-menu
                                                            ref="menuFechaBaja"
                                                            v-model="menuFechaBaja"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaBajaFormatted"
                                                                    label="Fecha de baja"
                                                                    readonly
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFechaBaja = parseDate(
                                                                            selectedCampos[i].value
                                                                        )
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFechaBaja"
                                                                no-title
                                                                scrollable
                                                                @input="menuFechaBaja = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Sexo'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="SEXOS"
                                                            label="Sexo"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template
                                                        v-else-if="campo.text === 'Padre' || campo.text === 'Madre'"
                                                    >
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="TUTORES"
                                                            :label="campo.text === 'Padre' ? 'Padre' : 'Madre'"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                            <template v-slot:item="data">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        v-html="
                                                                            data.item.nombre +
                                                                                ' ' +
                                                                                data.item.apellido_paterno +
                                                                                ' ' +
                                                                                data.item.apellido_materno
                                                                        "
                                                                    >
                                                                    </v-list-tile-title>
                                                                </v-list-tile-content>
                                                            </template>
                                                            <template v-slot:selection="data">
                                                                {{
                                                                    data.item.nombre +
                                                                        " " +
                                                                        data.item.apellido_paterno +
                                                                        " " +
                                                                        data.item.apellido_materno
                                                                }}
                                                            </template>
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Tipo de Sangre'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="SANGRES"
                                                            label="Sangre"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Tipo de servicio médico'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="SERVICIOS"
                                                            label="Servicio médico"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Agudeza visual'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { text: 'Normal', value: 1 },
                                                                { text: 'Disminuída', value: 2 },
                                                                { text: 'Usa lentes', value: 3 }
                                                            ]"
                                                            label="Agudeza visual"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Convive con'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { text: 'Madre', value: 1 },
                                                                { text: 'Padre', value: 2 },
                                                                { text: 'Madre y Padre', value: 3 },
                                                                { text: 'Ninguno', value: 4 }
                                                            ]"
                                                            label="Convivie con"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Estado de nutrición'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { text: 'Nutrición normal', value: 1 },
                                                                { text: 'Desnutrición moderada', value: 2 },
                                                                { text: 'Desnutrición severa', value: 3 }
                                                            ]"
                                                            label="Estado nutrición"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else>
                                                        <v-text-field
                                                            v-model="selectedCampos[i].value"
                                                            :label="campo.text"
                                                            autofocus
                                                            class="mt-3"
                                                        >
                                                        </v-text-field>
                                                    </template>
                                                </v-list-tile-content>

                                                <v-spacer></v-spacer>

                                                <v-scroll-x-transition>
                                                    <v-icon v-if="campo.activo" color="success">
                                                        fa-check
                                                    </v-icon>
                                                </v-scroll-x-transition>
                                            </v-list-tile>
                                        </template>
                                    </v-slide-y-transition>
                                </v-list>
                            </v-card>
                        </v-container>
                    </template>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"

export default {
    name: "CustomFilterEstudiante",
    props: {
        internalState: { type: Object, default: null }
    },
    data: () => ({
        inputs: Util.EstudianteCampos(),
        selectedCampos: [],

        //fecha nacimiento
        menuFechaNacimiento: false,
        dateFechaNacimiento: new Date().toISOString().substr(0, 10),

        //fecha alta
        menuFechaAlta: false,
        dateFechaAlta: new Date().toISOString().substr(0, 10),

        //fecha baja
        menuFechaBaja: false,
        dateFechaBaja: new Date().toISOString().substr(0, 10),

        //saber si se cargaron todos los datos necesarios para seleccionar
        showErrorDataLoadedAlert: false
    }),
    methods: {
        applyFilter() {
            let customFilter = ""
            this.selectedCampos.forEach(campo => {
                if (campo.activo) {
                    if (
                        campo.attribute === "fecha_nacido" ||
                        campo.attribute === "fecha_alta" ||
                        campo.attribute === "fecha_baja"
                    ) {
                        customFilter = customFilter + `${campo.attribute}=${this.parseDate(campo.value)}&`
                    } else {
                        customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                    }
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                internalState: {
                    inputs: this.inputs,
                    selectedCampos: this.selectedCampos
                }
            })
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        }
    },

    computed: {
        activeFilters() {
            return this.selectedCampos.filter(campo => campo.activo).length
        },

        ...mapGetters(["SEXOS", "TUTORES", "SANGRES", "SERVICIOS"]),

        computedFechaAltaFormatted() {
            this.inputs[8].value = this.formatDate(this.dateFechaAlta)
            return this.formatDate(this.dateFechaAlta)
        },

        computedFechaBajaFormatted() {
            this.inputs[9].value = this.formatDate(this.dateFechaBaja)
            return this.formatDate(this.dateFechaBaja)
        },

        computedFechaNacimientoFormatted() {
            this.inputs[5].value = this.formatDate(this.dateFechaNacimiento)
            return this.formatDate(this.dateFechaNacimiento)
        }
    },

    watch: {
        selectedCampos(val) {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TUTORES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SANGRES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SERVICIOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.internalState) {
            this.selectedCampos = this.internalState.selectedCampos
            this.inputs = this.internalState.inputs
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
